import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { ShipmentRouteType } from '../enums/ShipmentRouteType'

export class ShipmentRouteEntity {
  id?: string
  type?: ShipmentRouteType
  route?: Array<LngLatEntity> | null
  distance?: number
  duration?: number
}
